import React from "react";
import { TabPanels as ChakraTabPanels } from "@chakra-ui/react";
export function TabPanels(props) {
    return React.createElement(ChakraTabPanels, { ...props });
}
